var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconwritingRules = function SvgIconwritingRules(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 232,
    height: 163,
    viewBox: "0 0 232 163",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5891",
    x: 37,
    y: 41,
    width: 167,
    height: 104,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5906",
    x: 147,
    y: 101,
    width: 85,
    height: 62,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5907",
    x: 0,
    y: 71,
    width: 85,
    height: 62,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5893",
    x: 101,
    y: 0,
    width: 85,
    height: 62,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon.writing-rules",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_5891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5891-2",
    "data-name": "Rectangle 5891",
    width: 149,
    height: 86,
    rx: 5,
    transform: "translate(46 47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5895",
    "data-name": "Rectangle 5895",
    width: 118,
    height: 6,
    rx: 3,
    transform: "translate(53 59)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5896",
    "data-name": "Rectangle 5896",
    width: 101,
    height: 6,
    rx: 3,
    transform: "translate(53 73)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5897",
    "data-name": "Rectangle 5897",
    width: 61,
    height: 5,
    rx: 2.5,
    transform: "translate(53 87)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5898",
    "data-name": "Rectangle 5898",
    width: 85,
    height: 5,
    rx: 2.5,
    transform: "translate(53 101)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5899",
    "data-name": "Rectangle 5899",
    width: 33,
    height: 2,
    rx: 1,
    transform: "translate(53 81)",
    fill: "#e70d55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5905",
    "data-name": "Rectangle 5905",
    width: 64,
    height: 2,
    rx: 1,
    transform: "translate(53 67)",
    fill: "#1a74aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5902",
    "data-name": "Rectangle 5902",
    width: 16,
    height: 2,
    rx: 1,
    transform: "translate(85 94)",
    fill: "#3b9c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5903",
    "data-name": "Rectangle 5903",
    width: 24,
    height: 2,
    rx: 1,
    transform: "translate(68 108)",
    fill: "#1a74aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5904",
    "data-name": "Rectangle 5904",
    width: 8,
    height: 2,
    rx: 1,
    transform: "translate(120 108)",
    fill: "#e70d55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5900",
    "data-name": "Rectangle 5900",
    width: 11,
    height: 2,
    rx: 1,
    transform: "translate(98 81)",
    fill: "#1a74aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5901",
    "data-name": "Rectangle 5901",
    width: 23,
    height: 2,
    rx: 1,
    transform: "translate(121 81)",
    fill: "#3b9c7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3673",
    "data-name": "Group 3673",
    transform: "translate(-110 -753)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 101, 747)",
    filter: "url(#Rectangle_5906)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5906-2",
    "data-name": "Rectangle 5906",
    width: 67,
    height: 44,
    rx: 5,
    transform: "translate(156 107)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5909",
    "data-name": "Rectangle 5909",
    width: 18,
    height: 4,
    rx: 2,
    transform: "translate(265 873)",
    fill: "#e70d55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5911",
    "data-name": "Rectangle 5911",
    width: 18,
    height: 2,
    rx: 1,
    transform: "translate(265 859)",
    fill: "#f59ebb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5912",
    "data-name": "Rectangle 5912",
    width: 52,
    height: 2,
    rx: 1,
    transform: "translate(265 881)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5913",
    "data-name": "Rectangle 5913",
    width: 49,
    height: 2,
    rx: 1,
    transform: "translate(265 886)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5914",
    "data-name": "Rectangle 5914",
    width: 19,
    height: 2,
    rx: 1,
    transform: "translate(265 891)",
    fill: "#c5c5c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3674",
    "data-name": "Group 3674",
    transform: "translate(-109 -755)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 100, 749)",
    filter: "url(#Rectangle_5907)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5907-2",
    "data-name": "Rectangle 5907",
    width: 67,
    height: 44,
    rx: 5,
    transform: "translate(9 77)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5910",
    "data-name": "Rectangle 5910",
    width: 35,
    height: 4,
    rx: 2,
    transform: "translate(117 845)",
    fill: "#0b845c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5915",
    "data-name": "Rectangle 5915",
    width: 45,
    height: 2,
    rx: 1,
    transform: "translate(117 853)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5916",
    "data-name": "Rectangle 5916",
    width: 38,
    height: 2,
    rx: 1,
    transform: "translate(117 858)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5917",
    "data-name": "Rectangle 5917",
    width: 18,
    height: 2,
    rx: 1,
    transform: "translate(117 832)",
    fill: "#9dcdbd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3675",
    "data-name": "Group 3675",
    transform: "translate(-115 -760)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 106, 754)",
    filter: "url(#Rectangle_5893)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5893-2",
    "data-name": "Rectangle 5893",
    width: 67,
    height: 44,
    rx: 5,
    transform: "translate(110 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5908",
    "data-name": "Rectangle 5908",
    width: 38,
    height: 4,
    rx: 2,
    transform: "translate(224 779)",
    fill: "#1a74aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5920",
    "data-name": "Rectangle 5920",
    width: 51,
    height: 2,
    rx: 1,
    transform: "translate(224 787)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5921",
    "data-name": "Rectangle 5921",
    width: 7,
    height: 2,
    rx: 1,
    transform: "translate(224 797)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5919",
    "data-name": "Rectangle 5919",
    width: 51,
    height: 2,
    rx: 1,
    transform: "translate(224 792)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5918",
    "data-name": "Rectangle 5918",
    width: 18,
    height: 2,
    rx: 1,
    transform: "translate(224 765)",
    fill: "#b2d0e2"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_309",
    "data-name": "Line 309",
    x1: 25,
    y1: 9,
    transform: "translate(125.5 112.5)",
    fill: "none",
    stroke: "#f59ebb",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_310",
    "data-name": "Line 310",
    x1: 39,
    y1: 3,
    transform: "translate(41.5 91.5)",
    fill: "none",
    stroke: "#9dcdbd",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_311",
    "data-name": "Line 311",
    x1: 32,
    y2: 40,
    transform: "translate(73.5 25.5)",
    fill: "none",
    stroke: "#b2d0e2",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: "0.1 8"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconwritingRules);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.writing-rules.a4a0caef384238162d45ddf8b2f555f4.svg";